module.exports = __webpack_public_path__ + "img/bn.0adbb664.svg";